import { withRouter } from "react-router-dom"

import HeadTags from "./component"

export default withRouter(HeadTags)